import { ProtectedRoute } from "@app/protected-route";
import { AionDetail } from "@pages/aion-detail/aion-detail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/aion/$applicationId")({
	component: RouteComponent,
});

function RouteComponent() {
	const { applicationId } = Route.useParams();

	return (
		<ProtectedRoute requiredPermissions={["root", "see_all_logs"]}>
			<AionDetail applicationId={applicationId} />
		</ProtectedRoute>
	);
}
